module.exports = __webpack_public_path__ + "img/icon_person.922c03c0.svg";